import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/node/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/CompanyQuote/CompanyQuote.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/normalize.css/normalize.css");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Copyright/Copyright.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/HomeFooter/HomeFooter.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Layout/Layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/LegalPopup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/RichText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/containers/JobDetails/index.tsx");
